module.exports = __webpack_public_path__ + "img/slika33.c9c8fde3.jpg";